export default {
    colors: [
        '#0f1e82',
        '#4192dc',
        '#07094a',
        '#875ba3',
        '#6972b1'
    ],

    chart: {
        backgroundColor: '#f6f4f3',
    },

    exporting: {
        buttons: {
            contextButton: {
                symbolStroke: 'rgba(41, 38, 34, 0.6)',
                theme: {
                    fill: '#f7f6f5' // Background color of the burger menu
                }
            }
        }
    },

    title: {
        style: {
            color: '#07094A',
            fontSize: 44,
            fontWeight: 'bold',
            fontFamily: "Nykredit sans, Arial, sans-serif"
        }
    },

    subtitle: {
        style: {
            color: '#292622',
            fontSize: 18,
            fontFamily: "Nykredit sans, Arial, sans-serif"
        }
    },

    legend: {
        itemStyle: {
            color: '#292622',
            fontSize: 12,
            fontFamily: "Nykredit sans, Arial, sans-serif"
        },
        itemHoverStyle: {
            color: '#292622'
        }
    },

    tooltip: {
        headerFormat: '<span style="font-size: 18px;">{point.key}</span><br/>',
        style: {
            fontSize: 14
        }
    },

    xAxis: {
        title: {
            style: {
                color: '#292622',
                fontSize: 12,
                fontWeight: 'bold'
            }
        },
        labels: {
            style: {
                color: '#292622',
                fontSize: 12,
            }
        }
    },

    yAxis: {
        title: {
            style: {
                color: '#292622',
                fontSize: 12,
                fontWeight: 'bold'
            }
        },
        labels: {
            style: {
                color: '#292622',
                fontSize: 12
            }
        }
    },
    lang: {
        thousandsSep: '.'
    },
    credits: {
        enabled: false
    }
};
